import { useState } from "react";
import { IoIosArrowDown } from "react-icons/io";
import icon1 from '../../../assets/messages/businessman.png';
import icon2 from '../../../assets/messages/mortarboard.png';

import '../../style/mobile/messages/MMessages.scss';

let c=0;
const MMessages=()=>{
  const [data,setData]=useState([
    {
      id:1,
      department:"مدیریت",
      img:icon1,
      date:"1400/8/1",
      title:'خوش‌آمدگویی...',
      text:"سلام.خیلی خوشحالیم که آزما رو انتخاب کردید.امیدواریم استفاده از این سامانه تجربه دلپذیری برای شما باشد.",
      isNew:false,
    },
    {
      id:2,
      department:"آموزشی",
      img:icon2,
      date:"1400/8/10",
      title:'تغییر در تاریخ آزمون',
      text:"به اطلاع می‌رسانیم که آزمون ریاضی یازدهم با 1 روز  تأخیر در تاریخ 1400/8/7 برگزار خواهد شد.",
      isNew:true,
    },
  ])

  //open messageBox-------------------------
  const openMessageBox=(index)=>{
    if(c===0){
    let box = document.querySelectorAll(".MMessages-item");
    box[index].style.maxHeight="300px";
    c=1;
    }
    else{
      let box = document.querySelectorAll(".MMessages-item");
      box[index].style.maxHeight="70px";
      c=0;
    }
  }
  return(
    <div className="MMessages">
      <div className="MMessages-title">پیام‌ها</div>
      {data.map((item,index)=>(
        <div key={item.id} className="MMessages-item">
          <div className="MMessages-item-short-info">
            <img src={item.img} alt="department-icon" className="MMessages-item-short-info-icon"/>
            <div className="MMessages-item-short-info-department">{item.department}</div>
            <div className="MMessages-item-short-info-title">{item.title}</div>
            <div className="MMessages-item-short-info-situation">
              <div style={item.isNew?{backgroundColor:"#2E81E8"}:null} className="MMessages-item-short-info-situation-circle"></div>
              <div style={item.isNew?{color:"#2E81E8"}:null} className="MMessages-item-short-info-situation-text">
                {item.isNew && 'جدید'}
                {!item.isNew && 'خوانده شده'}
              </div>
            </div>
            <div className="MMessages-item-short-info-date">{item.date}</div>
            <IoIosArrowDown className="MMessages-item-short-info-open-icon" onClick={()=>openMessageBox(index)}/>
          </div>
          <div className="MMessages-item-text">{item.text}</div>
        </div>
      ))}
    </div>
  )
}

export default MMessages;